import React from 'react';
import { Provider } from 'react-redux';
import store from '../App.store';

const StoreContainer = ({ children }) => <Provider store={store}>{children}</Provider>;

export default StoreContainer;
